import { frontendURL } from '../../../helper/URLHelper';
import SalesPipelineIndex from './pages/SalesPipelineIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/sales-pipeline'),
    name: 'sales_pipeline_index',
    component: SalesPipelineIndex,
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'crm_manage'],
    },
  },
];
